import * as THREE from 'three';
import type { RotateBlock } from '@vrlearning/lesson-schema';
import { spinner } from '../windmill.js';
import type { StatefulBlock } from './features.js';
import type { PartRegistry } from './parts.js';

/**
 * The rotate block (V2): the meshes named `part…` hung from a pivot at `pivot` and turned about `axis`
 * at `speed` turns a minute, coming up to speed over `lag` seconds as the code mill's sails do.
 */
export function buildRotateBlock(
  root: THREE.Object3D,
  block: RotateBlock,
  parts: PartRegistry,
): StatefulBlock & { tick(dt: number): void } {
  const pivot = new THREE.Group();
  pivot.name = `${block.id}-draaipunt`;
  pivot.position.set(...block.pivot);
  root.add(pivot);
  const axis = new THREE.Vector3(...block.axis).normalize();
  // One turn a minute is 2π / 60 radians a second; the spinner's target is the speed in turns a minute.
  const spin = spinner({ lag: block.lag, radiansPerSecond: (2 * Math.PI) / 60 });
  let target = block.speed;
  parts.when([block.part], (meshes) => {
    // Keeps each mesh where it is, now under the pivot.
    for (const mesh of meshes) pivot.attach(mesh);
  });
  const tick = (dt: number): void => {
    spin.update(dt, target);
    pivot.quaternion.setFromAxisAngle(axis, spin.angle);
  };
  return {
    tick,
    set(setting, value) {
      if (setting === 'speed') target = value as number;
    },
    snap() {
      spin.snap(target);
    },
  };
}
